import { __assign, __rest } from "tslib";
import React from 'react';
import { cnCalendar } from '../Calendar.const';
import { View } from '../View';
import './BaseCalendar.css';
export var BaseCalendar = function (props) {
    var state = props.state, className = props.className, otherProps = __rest(props, ["state", "className"]);
    var views = state.views;
    return (React.createElement("div", { className: cnCalendar(null, [className]) }, views.map(function (viewProps, index) { return (React.createElement(View, __assign({ key: index }, viewProps, otherProps, { index: index, state: state }))); })));
};
